import React from 'react'
import { Card, Button, Box, Typography, Grid } from '@mui/material'
import RFG from "../../libs/inputs/RFG"
import { useDispatch, useSelector } from "react-redux"
import { useForm } from 'react-hook-form'
import { FORGOT } from "../../services/actions"
import { BsEyeFill, BsEyeSlashFill } from "react-icons/bs"
import { useNavigate } from 'react-router-dom'
import authImg from '../../layouts/yellow_white_logo.png'
import bgImg from './bg.jpg'
const centerBoxFlex = {
  overflow: 'hidden',
  height: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}

export default function ForgotPassword() {
  let dispatch = useDispatch()
  const navigate = useNavigate()
  let user = useSelector((state) => state?.loginState.auth)
  const { handleSubmit, control } = useForm({
    defaultValues: {},
    mode: "all"
  })

  return (
    <>
      <Box sx={{ ...centerBoxFlex }}>
        <Box sx={{ ...centerBoxFlex, width: 1, position: 'absolute' }}>


          <Box sx={{
            minWidth: { md: 470, xs: 210 },
            background: '#000000b8', px: 6, py: 5,
            borderRadius: 4
          }}>
            <Box sx={{ textAlign: 'center' }}>
              <Box component={'img'} src={authImg} />
            </Box>
            <Box sx={{ mt: 3 }}>
              <Typography fontSize={16} fontWeight={400} color="#fff">Forgot Password</Typography>

            </Box>
            <Box>
              <Typography fontSize={13} sx={{ mb: 2 }} color="#ffffffff">Welcome to widelapse monitoring system</Typography>
            </Box>
            <Box>
              <form autoComplete="false" onSubmit={handleSubmit((data) => {
                data.reset_url = `${window.location.origin}/#/reset-password`;
                console.log("DATA", data)
                dispatch({ type: `${FORGOT}_POST`, payload: data });
              })}>
                <RFG labelStyle={{ color: "#717171" }} name="email" label="Email" control={control} rules={{ required: true }} className="mb-2">
                  <input autoComplete="false" style={{ borderRadius: 12, color: "#717171" }} />
                </RFG>


                <Button sx={{
                  width: 1, my: 2, background: '#ffd85f',
                  color: '#000', borderRadius: 2, textTransform: 'capitalize'
                }} type="submit">Forgot Password</Button>
                <Button type="button"
                  onClick={() => { navigate('/') }}
                  sx={{
                    width: 1, my: 2, background: '#000000ff', color: '#ffd85f',
                    borderRadius: 2, textTransform: 'capitalize', border: '1px solid white'
                  }} >Login</Button>
              </form>
              <Box fontSize={12} className="error">{user?.message}</Box>
              <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
                <Typography sx={{ mt: 2, fontSize: 12, textAlign: 'right', color: "#c2c2c2ff" }}>Powered by widelapse</Typography>
                <Typography sx={{ mt: 2, fontSize: 12, textAlign: 'right', color: "#c2c2c2ff" }}>Terms & conditions</Typography>
              </Box>
            </Box>
          </Box>



          {/* <Grid size={{ xs: 12, sm: 12, md: 7 }} sx={{ p: '1%', display: { xs: 'none', sm: 'none', md: 'block' } }}>
            <Box display={'flex'} alignItems={'center'} justifyContent={'center'}
              sx={{
                width: 1, height: '80vh', overflow: 'hidden', borderRadius: 3
              }}>
              <img height={'100%'} src={"https://images.pexels.com/photos/2341830/pexels-photo-2341830.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"} />
            </Box>
          </Grid> */}



        </Box >
        <Box component={'img'}
          src={bgImg} sx={
            {
              width: { xs: 'auto', sm: '100%' },
              height: { xs: '100vh' }
            }
          }
        />
      </Box >
    </>
  )
}

